export const characters = [
    {
        id: 'aoko',
        name: 'AOZAKI AOKO',
        nameJp: '蒼崎 青子',
        title: '',
        description: '',
        colors: ['#dc2626', '#ef4444', '#fca5a5'],  // 红发
        mainColor: '#ef4444',
        image: '/assets/images/new/aoko.png',
        hoverImage: '/assets/images/new/aoko-hover.png',
        imagePosition: '20% top' 
    },
    {
        id: 'satsuki',
        name: 'YUMIZUKA SATSUKI',
        nameJp: '弓塚 さつき',
        title: '',
        description: '',
        colors: ['#78350f', '#a16207', '#d97706'],  // 棕发
        mainColor: '#a16207',
        image: '/assets/images/new/satsuki.png',
        hoverImage: '/assets/images/new/satsuki-hover.png'
    },
    {
        id: 'ciel',
        name: 'CIEL',
        nameJp: 'シエル',
        title: '',
        description: '',
        colors: ['#1e40af', '#2563eb', '#60a5fa'],  // 蓝发
        mainColor: '#2563eb',
        image: '/assets/images/new/ciel.png',
        hoverImage: '/assets/images/new/ciel-hover.jpg'
    },
    {
        id: 'arcueid',
        name: 'ARCUEID BRUNESTUD',
        nameJp: 'アルクェイド・ブリュンスタッド',
        title: '',
        description: '',
        colors: ['#f5d742', '#e6c832', '#fae97a'],  // 金发
        mainColor: '#f5d742',
        image: '/assets/images/new/arcueid.png',
        hoverImage: '/assets/images/new/arcueid-hover.png'
    },
    {
        id: 'akiha',
        name: 'TOHNO AKIHA',
        nameJp: '遠野 秋葉',
        title: '',
        description: '',
        colors: ['#1f1f1f', '#3d3d3d', '#6b21a8'],  // 黑发带紫
        mainColor: '#3d3d3d',
        image: '/assets/images/new/akiha.png',
        hoverImage: '/assets/images/new/akiha-hover.png'
    },
    {
        id: 'kohaku',
        name: 'KOHAKU',
        nameJp: '琥珀',
        title: '',
        description: '',
        colors: ['#ea580c', '#f97316', '#fdba74'],  // 琥珀橙（橙发）
        mainColor: '#f97316',
        image: '/assets/images/new/kohaku.png',
        hoverImage: '/assets/images/new/kohaku-hover.png'
    },
    {
        id: 'hisui',
        name: 'HISUI',
        nameJp: '翡翠',
        title: '',
        description: '',
        colors: ['#0d9488', '#14b8a6', '#5eead4'],  // 翡翠绿（深蓝绿发）
        mainColor: '#14b8a6',
        image: '/assets/images/new/hisui.png',
        hoverImage: '/assets/images/new/hisui-hover.jpg'
    }
]